import React from 'react';
import PropTypes from 'prop-types';
import SMStream from '../streams/SMStream2';

const smWidgets = ({ tournamentId, teamId, seasonId, playerId }) => {
    return [
        {
            name: 'PlayerLatestMatchesFormSMWidget',
            props: {
                teamId,
                playerId,
                seasonIds: [seasonId],
                incedentType: 'goals',
            },
        },
        {
            name: 'PlayerLatestMatchesFormSMWidget',
            props: {
                teamId,
                playerId,
                seasonIds: [seasonId],
                incedentType: 'assists',
            },
        },
        {
            name: 'PlayerLatestMatchesFormSMWidget',
            props: {
                teamId,
                playerId,
                seasonIds: [seasonId],
                incedentType: 'goals+assists',
            },
        },
        {
            name: 'PlayerLatestMatchesFormSMWidget',
            props: {
                teamId,
                playerId,
                seasonIds: [seasonId],
                incedentType: null,
                limit: 12,
            },
        },
        {
            name: 'PlayerProfileAdvSMWidget',
            props: {
                teamId,
                playerId,
            },
        },
        {
            name: 'PlayerProfileOpta',
            props: {
                teamId,
                playerId,
                ttIds: tournamentId,
                seasonIds: seasonId,
            },
        },
    ];
};

function PlayerSeasonSMB({ params }) {
    return <SMStream smWidgets={smWidgets(params)} title="Player vs Player" />;
}

PlayerSeasonSMB.propTypes = {
    params: PropTypes.shape({
        tournamentId: PropTypes.string.isRequired,
        seasonId: PropTypes.string.isRequired,
        teamId: PropTypes.string.isRequired,
        playerId: PropTypes.string.isRequired,
    }).isRequired,
};

export default PlayerSeasonSMB;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/sm/pages/PlayerSeasonSMB.js
 **/